import { selectorFamily } from 'recoil';
import { endpointEnum } from '../../services/rest/makeAPIRequest';
import querystring from 'querystring';
import { user } from '../atoms/user';
import { startingDate } from '../atoms/startingDate';
import { endingDate } from '../atoms/endingDate';
import moment from 'moment';
import { getApiMutation } from '../../services/rest/getApiMutation';

export const cadenceActionProcess = selectorFamily({
  key: 'cadenceActionProcess',
  get: ({ page, pageSize, search, inflight, status, sortModel, featureFlagTreatment }) => async ({
    get,
  }) => {
    const storageUser = get(user);
    try {
      let sortModelField = sortModel[0].field;
      if (
        sortModelField &&
        sortModelField.indexOf('.') !== sortModelField.lastIndexOf('.')
      ) {
        sortModelField = sortModelField.slice(sortModelField.indexOf('.') + 1);
      }
      const sort = `&sort=${sortModelField}:${sortModel[0].sort}`;
      let suffix = '';
      const start = get(startingDate);
      const end = get(endingDate);
      // if we are looking at completed actions
      const statusFilter = !inflight // (not ingflight actions)
        ? // if the status is not set to all
          status !== 'all'
          ? // then search for the selected status (completed or incomplete)
            `~status:${status}`
          : // otherwise we assume its set to all, filter to completed and incomplete only
            '~status*:completed,incomplete'
        : // otherwise we assume we are looking at inflight actions, filter to processing and scheduled status's only
          '~status*:processing,scheduled';
      if (search.length >= 1) {
        // Feature flag: use new search logic (with cadenceName search fixed)
        if (featureFlagTreatment === 'on') {
          suffix = `or$:cadenceProcess.targetPhoneNumber%25:%25${search}%25,cadence.cadenceName%25:%25${search}%25`;
        } else {
          // Old behavior: original code (cadenceName search was malformed)
          suffix = `or$:cadenceProcess.targetPhoneNumber%25:%25${search}%25,cadence.cadenceName%25:%25~businessId:${storageUser.businessid}`;
        }
      } else {
        suffix = '';
      }
      const dates = `${!!suffix.length ? '~' : ''}${
        inflight ? 'createdDate' : 'completedDate'
      }-:${moment(start).startOf('day').toISOString()},${moment(end)
        .endOf('day')
        .toISOString()}`;
      const endpoint =
        `${endpointEnum.CADENCE_ACTION_PROCESS}?` +
        querystring.stringify({
          page: page - 1,
          pageSize,
        }) +
        '&filter=' +
        suffix +
        dates +
        statusFilter +
        `~businessId:${storageUser.businessid}` +
        sort;

      const mutation = getApiMutation(storageUser);
      const response = await mutation({
        endpoint,
        method: 'get',
      });

      // console.log(endpoint, 'endpoint');
      return response;
    } catch (error) {
      throw error;
    }
  },
});
// const sample = {
//   cadenceActionProcessId: 310,
//   cadenceProcessId: 262,
//   cadenceActionId: 1,
//   businessId: '995',
//   actionIndex: 1,
//   type: 'sms',
//   durationFromLastActionMin: 2600,
//   retryCallEnabled: true,
//   maxRetries: 3,
//   callRetryInMin: 5400,
//   smsTemplateId: null,
//   smsMessage: 'Hi how you doin ?',
//   scheduledDate: '2021-03-19T17:53:28.000Z',
//   completedDate: '2021-03-19T18:23:15.000Z',
//   firstAttemptDate: null,
//   retryCount: null,
//   status: 'completed',
//   substatus: 'completed',
//   delayReasons: null,
//   updatedDate: '2021-03-20T01:23:15.000Z',
//   createdDate: '2021-03-20T00:53:29.000Z',
//   cadenceProcess: {
//     cadenceProcessId: 262,
//     cadenceId: 158,
//     businessId: '995',
//     userId: null,
//     cadenceVersion: 12,
//     targetPhoneNumber: '310-447-4156',
//     triggerDate: '2021-03-19T17:53:29.000Z',
//     status: 'completed',
//     substatus: 'completed',
//     updatedDate: '2021-03-22T05:10:18.000Z',
//     createdDate: '2021-03-20T00:53:29.000Z',
//     targetTimeZone: 'PST',
//     cadence: {
//       cadenceId: 158,
//       businessId: '995',
//       status: 'active',
//       cadenceName: 'name',
//       eventUrl: 'event.com',
//       checkDncEnabled: true,
//       reEnrollmentEnabled: true,
//       useContactOwnerEnabled: true,
//       assignContactOwner: 'autoAssignFromQueue',
//       version: 12,
//       queueId: '496',
//       cadenceHours: {
//         1: {
//           day: 'Monday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         2: {
//           day: 'Tuesday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         3: {
//           day: 'Wednesday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         4: {
//           day: 'Thursday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         5: {
//           day: 'Friday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//       },
//       targetHours: {
//         1: {
//           day: 'Monday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         2: {
//           day: 'Tuesday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         3: {
//           day: 'Wednesday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         4: {
//           day: 'Thursday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//         5: {
//           day: 'Friday',
//           hours: [
//             {
//               endTime: '18:00',
//               startTime: '09:00',
//             },
//           ],
//         },
//       },
//       updatedDate: '2021-03-24T22:37:51.000Z',
//       createdDate: '2021-02-24T01:12:17.000Z',
//     },
//   },
// };
